import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, Meta, SafeHtml, Title } from '@angular/platform-browser';
import * as mammoth from 'mammoth';



@Component({
  selector: 'app-basesegresados',
  templateUrl: './basesegresados.component.html',
  styleUrls: ['./basesegresados.component.scss']
})
export class BasesegresadosComponent implements OnInit {
  htmlContent: SafeHtml = '';
  constructor(private http: HttpClient,
    private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
    this.cargarLegal();
  }

  cargarLegal() {
    const url = '/assets/docs/bases-egresados.docx';

    this.http.get(url, { responseType: 'arraybuffer' }).subscribe({
      next: (arrayBuffer: ArrayBuffer) => {
        mammoth.convertToHtml({ arrayBuffer: arrayBuffer })
          .then((result) => {
            // Sanitizamos el HTML generado para inyectarlo de forma segura en la vista
            this.htmlContent = this.sanitizer.bypassSecurityTrustHtml(result.value);

            if (result.messages.length > 0) {
              console.warn('Mensajes de Mammoth:', result.messages);
            }
          })
          .catch((error) => {
            console.error('Error al convertir el documento Word:', error);
          });
      },
      error: (error) => {
        console.error('Error al cargar el archivo de assets:', error);
      }
    });
  }

}
